import {ContractType} from '../warranties/contract-type.model';

export class AdminPromotion {

  id: number;
  createdBy: string;
  dateCreated: string;

  selectedRegions: string[] = [];
  selectedDealers: string[] = [];
  selectedModels: string[] = [];
  selectedSources: string[] = [];
  selectedVins: string[] = [];
  documentUrls: string[] = [];
  selectedContractType: ContractType = null;
  selectedContractCode: string = null;
  dateFrom: string;
  dateTo: string;
  description: string;
  discount: number;
  selectedBrand: string = null;
  dateMade: string;
  warrantyCreationDateFrom: string;
  warrantyCreationDateTo: string;
}
